import React, { useEffect, useRef, useState } from 'react'
import * as d3 from 'd3'
import './Graph.css'

function formatearNumero(numero) {
  // Convertir el número a string
  const numStr = numero.toString();
  
  // Separar la parte entera y decimal
  const partes = numStr.split('.');
  const parteEntera = partes[0];
  
  // Formatear la parte entera
  const longitud = parteEntera.length;
  let resultado;
  
  if (longitud <= 3) {
      resultado = parteEntera;
  } else if (longitud <= 6) {
      resultado = `${parteEntera.slice(0, -3)},${parteEntera.slice(-3)}`;
  } else {
      const millones = parteEntera.slice(0, -6);
      const miles = parteEntera.slice(-6, -3);
      const cientos = parteEntera.slice(-3);
      resultado = `${millones}'${miles},${cientos}`;
  }
  
  // Agregar la parte decimal si existe
  if (partes.length > 1) {
      resultado += `.${  partes[1]}`;
  }
  
  return resultado;
}
const Graph = ({ datosPuntos, datosEventos, medidasPonderadas, handleDeleteEventById }) => {
  const types = [
    {
      name: 'REAL',
      imgUrl:
        'https://lucia-static.lucia.com.co/img/grafica/cube.png',
    },
    {
      name: 'BASELINE',
      imgUrl:
        'https://lucia-static.lucia.com.co/img/grafica/star.png',
    },
    {
      name: 'CATEGORY',
      imgUrl:
        'https://lucia-static.lucia.com.co/img/grafica/triangle.png',
    },
    {
      name: 'GERENTE',
      imgUrl:
        'https://lucia-static.lucia.com.co/img/grafica/square.png',
    },
    {
      name: 'JUNTA',
      imgUrl:
        'https://lucia-static.lucia.com.co/img/grafica/circle.png',
    },
    {
      name: 'SINCRONIZACION',
      imgUrl:
        'https://lucia-static.lucia.com.co/img/grafica/pentagon.png',
    },
  ]

  const [puntos1, setPuntos1] = useState([])
  const [typesVisibilidad, setTypeVisibilidad] = useState(
    types.flatMap((punto) => [
      { name: punto.name, visible: true, time: 'p' },
      { name: punto.name, visible: true, time: 'f' },
    ]),
  )

  const transformarDatos = (datosEntrada) => {
    console.log(datosEntrada, "datos")
    const resultado = []
    datosEntrada.forEach((dato) => {
      const fecha = new Date(dato.mes_unix * 1000)
      resultado.push(
        {
          fecha,
          valor: dato.baseline,
          type: 'REAL',
          id: `${dato.mes_unix}-REAL`,
        },
        {
          fecha,
          valor: dato.baseline_prediccion,
          type: 'BASELINE',
          id: `${dato.mes_unix}-BASELINE`,
        },
        {
          fecha,
          valor: dato.category,
          type: 'CATEGORY',
          id: `${dato.mes_unix}-CATEGORY`,
        },
        {
          fecha,
          valor: dato.gerente,
          type: 'GERENTE',
          id: `${dato.mes_unix}-GERENTE`,
        },
        {
          fecha,
          valor: dato.junta,
          type: 'JUNTA',
          id: `${dato.mes_unix}-JUNTA`,
        },
        {
          fecha,
          valor: dato.sincronizacion,
          type: 'SINCRONIZACION',
          id: `${dato.mes_unix}-SINCRONIZACION`,
        },
      )
    })
    return resultado
  }

  useEffect(() => {
    const datosTransformados = transformarDatos(datosPuntos)
    setPuntos1(datosTransformados)
  }, [datosPuntos])

  const [x, setX] = useState('')

  useEffect(() => {
    const timer = setTimeout(() => setX('c'), 1000)
    return () => clearTimeout(timer)
  }, [])

  const ancho = 700
  const alto = 400
  const margenSuperior = 10
  const margenDerecho = 10
  const margenInferior = 20
  const margenIzquierdo = 30

  const Grafica1 = ({ datos }) => {
    const svgRef = useRef()
    const [tooltipContent, setTooltipContent] = useState(null)
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 })

    useEffect(() => {
      if (datos.length === 0) return

      const fechaActual = new Date()
      
      // Calcular las fechas límite (12 meses antes y después de la fecha actual)
      const fechaMinima = d3.timeMonth.offset(fechaActual, -12)
      const fechaMaxima = d3.timeMonth.offset(fechaActual, 12)
  
      const valorMaximoY = d3.max(datos, (d) => d.valor)

      const escalaX = d3
        .scaleUtc()
        .domain([fechaMinima, fechaMaxima])
        .range([margenIzquierdo, ancho - margenDerecho])

      const escalaY = d3
        .scaleLinear()
        .domain([0, valorMaximoY])
        .range([alto - margenInferior, margenSuperior])

      const svg = d3
        .select(svgRef.current)
        .attr('width', ancho)
        .attr('height', alto)

      svg.selectAll('*').remove()

      svg
        .append('g')
        .attr('class', 'eje-x')
        .attr('transform', `translate(0,${alto - 25})`)
        .call(d3.axisBottom(escalaX))

      svg
        .append('g')
        .attr('class', 'eje-y')
        .attr('transform', `translate(${366},0)`)
        .call(d3.axisLeft(escalaY))

      svg.on('wheel', (evento) => {
        evento.preventDefault()
      })

      const zoomY = d3
        .zoom()
        .scaleExtent([1, 8])
        .on('zoom', (evento) => {
          const nuevaEscalaY = evento.transform.rescaleY(escalaY)
          svg.select('.eje-y').call(d3.axisLeft(nuevaEscalaY))
          svg.selectAll('.imagen').attr('y', (d) => nuevaEscalaY(d.valor))
        })

      svg.call(zoomY)

      svg
        .selectAll('.punto')
        .data(datos)
        .enter()
        .append('image')
        .attr('class', 'imagen')
        .attr('x', (d) => escalaX(d.fecha))
        .attr('y', (d) => escalaY(d.valor))
        .attr('width', 30)
        .attr('height', 30)
        .attr('xlink:href', (d) => {
          if (d.fecha > fechaActual && d.type === 'REAL') {
            return null // No mostrar puntos "REAL" en el futuro
          }
          if (d.fecha > fechaActual) {
            if (
              !typesVisibilidad.find(
                (type) => type.name === d.type && type.time === 'f',
              ).visible
            ) {
              return null
            }
            return types.find(type => type.name === d.type).imgUrl;
          }
          if (
            !typesVisibilidad.find(
              (type) => type.name === d.type && type.time === 'p',
            ).visible
          ) {
            return null
          }
          return types.find(type => type.name === d.type).imgUrl;
        })
        .on('mouseover', (event, d) => {
          setTooltipContent(`
            Tipo: ${d.type}
            Fecha: ${d.fecha.toLocaleDateString()}
            Valor: ${formatearNumero(d.valor.toFixed(2))}
          `)
          setTooltipPosition({ x: event.pageX, y: event.pageY })
        })
        .on('mouseout', () => {
          setTooltipContent(null)
        })
    }, [datos])

    return (
      <>
        <svg ref={svgRef} />
        {tooltipContent && (
          <div
            style={{
              position: 'absolute',
              left: `${tooltipPosition.x + 10}px`,
              top: `${tooltipPosition.y + 10}px`,
              background: 'white',
              border: '1px solid black',
              padding: '5px',
              borderRadius: '5px',
              pointerEvents: 'none',
            }}
          >
            <pre>{tooltipContent}</pre>
          </div>
        )}
      </>
    )
  }

 
  const Grafica2 = ({ datos }) => {
    const svgRef = useRef()
    const [isOpen, setIsOpen] = useState(false)
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [eventValues, setEventValues] = useState({})
  
    const openModal = (evento) => {
      setSelectedEvent(evento)
      setEventValues(evento.valores.reduce((acc, val) => {
        acc[val.mes_unix] = val.valor
        return acc
      }, {}))
      setIsOpen(true)
    }
  
    const closeModal = () => {
      setIsOpen(false)
      setSelectedEvent(null)
      setEventValues({})
    }
  
    useEffect(() => {
      const fechaActual = new Date()
      const fechaMinima = d3.timeMonth.offset(fechaActual, -12)
      const fechaMaxima = d3.timeMonth.offset(fechaActual, 12)
  
      const ancho = 700 // Ancho fijo del SVG
      const margenSuperior = 20
      const margenInferior = 20
      const margenIzquierdo = 30
      const margenDerecho = 10
      const alturaEvento = 60 // Altura para cada evento
      const espacioEntreEventos = 20 // Espacio entre eventos
  
      // Calcular la altura total necesaria
      const altoTotal = margenSuperior + 
                        (datos.length * (alturaEvento + espacioEntreEventos)) - 
                        espacioEntreEventos + 
                        margenInferior
  
      const escalaX = d3
        .scaleUtc()
        .domain([fechaMinima, fechaMaxima])
        .range([margenIzquierdo, ancho - margenDerecho])
  
      const svg = d3
        .select(svgRef.current)
        .attr('width', ancho)
        .attr('height', altoTotal)
  
      svg.selectAll('*').remove()
  
      const meses = d3.timeMonths(fechaMinima, fechaMaxima)
      meses.forEach((mes) => {
        const xInicio = escalaX(mes)
        svg
          .append('line')
          .attr('class', 'linea-mes')
          .attr('x1', xInicio)
          .attr('y1', margenSuperior)
          .attr('x2', xInicio)
          .attr('y2', altoTotal - margenInferior)
          .style('stroke', '#ccc')
          .style('stroke-width', '1px')
          .style('stroke-dasharray', '4')
      })
  
      datos.forEach((evento, index) => {
        const yOffset = margenSuperior + index * (alturaEvento + espacioEntreEventos)
  
        svg
          .append('text')
          .attr('x', margenIzquierdo)
          .attr('y', yOffset)
          .text(evento.nombre)
          .attr('font-size', '12px')
          .attr('alignment-baseline', 'hanging')
  
        const valorMaximo = d3.max(evento.valores, d => Math.abs(d.valor))
        const escalaY = d3
          .scaleLinear()
          .domain([-valorMaximo, valorMaximo])
          .range([yOffset + alturaEvento - 5, yOffset + 5])
  
        // Línea que separa positivos y negativos
        svg
          .append('line')
          .attr('x1', margenIzquierdo)
          .attr('y1', escalaY(0))
          .attr('x2', ancho - margenDerecho)
          .attr('y2', escalaY(0))
          .style('stroke', '#000')
          .style('stroke-width', '1px')
  
        evento.valores.forEach((valor) => {
          const fecha = new Date(valor.mes_unix * 1000)
          const x = escalaX(fecha)
          
          const fechaFinMes = d3.timeMonth.offset(fecha, 1)
          const anchoMes = escalaX(fechaFinMes) - x
          
          const y = escalaY(valor.valor)
          const altoRectangulo = Math.abs(escalaY(0) - y)
  
          svg
            .append('rect')
            .attr('x', x)
            .attr('y', valor.valor >= 0 ? y : escalaY(0))
            .attr('width', anchoMes)
            .attr('height', altoRectangulo)
            .attr('fill', valor.valor >= 0 ? 'blue' : 'red')
            .attr('opacity', 0.4)
            .on('click', () => openModal(evento))
        })
      })
    }, [datos])
  
    const handleChangeValue = (mesUnix, increment) => {
      setEventValues(prevValues => ({
        ...prevValues,
        [mesUnix]: prevValues[mesUnix] + (increment ? 1 : -1)
      }))
    }
  
    const handleEdit = (mesUnix) => {
      if (selectedEvent) {
        const fechaActual = new Date()
        const fechaEjecucion = fechaActual.toISOString().split('T')[0] // Formato YYYY-MM-DD
  
        const objetoEdicion = {
          "evento_id": selectedEvent.id,
          "material": selectedEvent.material, // Asumiendo que el evento tiene una propiedad 'material'
          "ejecucion": fechaEjecucion,
          "cantidad": eventValues[mesUnix].toString()
        }
  
        console.log(objetoEdicion)
      }
    }

    const handleDelete = () => {
      console.log('Eliminar evento con ID:', selectedEvent.id)
      handleDeleteEventById(selectedEvent.id)
      closeModal()  
    }
  
    return (
      <>
        {isOpen && selectedEvent && (
          <div className="modal_container">
            <div className="modal-content">
              <span className="close" onClick={closeModal}>&times;</span>
              <p>{selectedEvent.nombre}</p>
              {selectedEvent.valores.map((valor) => {
                const date = new Date(valor.mes_unix * 1000)
                const month = date.toLocaleString('default', { month: 'long' })
                return (
                  <div key={valor.mes_unix} className="event-value">
                    <span>{month}</span>
                    {/* <input 
                      type="number" 
                      value={eventValues[valor.mes_unix]} 
                      readOnly 
                    />
                    <button onClick={() => handleChangeValue(valor.mes_unix, true)}>+</button>
                    <button onClick={() => handleChangeValue(valor.mes_unix, false)}>-</button> */}
                     <p>{valor.mes_unix}</p>
                    {/* <button onClick={() => handleEdit(valor.mes_unix)}>Editar</button> */}
                    <button onClick={() => handleDelete()}>Eliminar</button>
                  </div>
                )
              })}
            </div>
          </div>
        )}
        <svg ref={svgRef} />
      </>
    )
  }

  const handleToogleEvent1 = (name, time) => {
    setTypeVisibilidad((prevTypes) =>
      prevTypes.map((type) =>
        type.name === name && type.time === time
          ? { ...type, visible: !type.visible }
          : type,
      ),
    )
  }

  return (
    <div className={x}>
      {x && (
        <>
          <div className="graph_top">
            <div className="graph_top-historico">
              <h4>HISTORICO</h4>
              <p>WBIAS {medidasPonderadas && (parseFloat(medidasPonderadas.WBIAS) * 100).toFixed(2)}%</p>
              <p>WMAPE {medidasPonderadas && (parseFloat(medidasPonderadas.WMAPE) * 100).toFixed(2)}% </p>
            </div>
            <div className="graph_top-planeacion">
              {/* <h4>PLANEACION</h4>
              <p>BIAS XXXX / 40%</p>
              <p>Mape XXXX / 35%</p> */}
            </div>
          </div>
          <div className="graph_center">
            <div className="graph_center-left">
              <div className="graph_center-left-top">
                {types.map((type) => (
                  <div key={type.name} className="graph_type-container">
                    <img
                      className="graph_type-container-img"
                      src={type.imgUrl}
                      alt=""
                    />
                    <p className="graph_type-container-p">{type.name}</p>
                    <input
                      className="graph_type-container-input"
                      type="checkbox"
                      onChange={() => handleToogleEvent1(type.name, 'p')}
                      checked={
                        typesVisibilidad.find(
                          (p) => p.name === type.name && p.time === 'p',
                        ).visible
                      }
                    />
                  </div>
                ))}
              </div>
              <div className="graph_center-left-bottom">
                <h4>Eventos</h4>
                {datosEventos.map((evento) => (
                  <div key={evento.nombre} className="graph_type-container">
                    <p className="graph_type-container-p-max">
                      {evento.nombre}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="graph_center-center">
              <Grafica1 datos={puntos1} />
              <div className="graph2_container">
                <Grafica2 datos={datosEventos} />
              </div>
            </div>
            <div className="graph_center-right">
              {types.map((type) => type.name !== "REAL" ? (
                <div key={type.name} className="graph_type-container">
                  <img
                    className="graph_type-container-img"
                    src={type.imgUrl}
                    alt=""
                  />
                  <p className="graph_type-container-p">{type.name}</p>
                  <input
                    className="graph_type-container-input"
                    type="checkbox"
                    onChange={() => handleToogleEvent1(type.name, 'f')}
                    checked={
                      typesVisibilidad.find(
                        (p) => p.name === type.name && p.time === 'f',
                      ).visible
                    }
                  />
                </div>
              ): null)}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Graph